import React from 'react';
import PropTypes from 'prop-types';
import { renderStars, renderPerfectFor, getPercentage, formatXMoney } from './../helpers';
import { HotelMobile as S } from './../styles';

class HotelMobile extends React.Component {
  handleClick = (hotel) => {
    this.props.modal(true);
    this.props.selectedHotel(hotel);
  }
  renderNoPrice = (hotel) => {
    return (
      <S.Price>
        <h3>
          <strong>Price on enquiry</strong>
        </h3>
        <button onClick={() => this.handleClick(this.props.hotel)} data-hotel-name={hotel.name}>See Rooms</button>
      </S.Price>
    );
  }
  renderPrice = (hotel) => {
    const origPrice = hotel.strike_through_price;
    return (
      <S.Price>
        <h3>
          <small>From: </small>
          <strong>THB {formatXMoney(hotel.notes, 'XXX')} (~${formatXMoney(hotel.price, 'XX')}+)<span className="asterisk">*</span></strong> <strike>~${formatXMoney(origPrice, 'XXX')}</strike>
        </h3>
        <button onClick={() => this.handleClick(this.props.hotel)} data-hotel-name={hotel.name}>See Rooms</button>
      </S.Price>
    );
  }
  render() {
    const {
      hotel: {
        id,
        images,
        name,
        distance,
        stars,
        rating,
        price,
        perfectFor,
        hotelMarker,
        priceOnEnquiry,
      },
    } = this.props;
    const origPrice = this.props.hotel.strike_through_price;
    return (
      <S.Wrapper id={`hotel-${id}`}>
        <S.Info>
          <div className="image" style={{ backgroundImage: `url(${images[0]})` }}>
            {!priceOnEnquiry && <span className="save">{getPercentage(origPrice, price)}% off</span>}
          </div>
          <div className="details">
            <img src={hotelMarker} alt={name} />
            <h5>{renderStars(stars)} <span className="rating">Rating: {rating}</span></h5>
            <h3>{name}</h3>
            <p>Distance to venue: {distance < 100 ? (`${distance}-min walk`) : 'varies'}</p>
            {renderPerfectFor(perfectFor)}
          </div>
        </S.Info>
        {priceOnEnquiry ? this.renderNoPrice(this.props.hotel) : this.renderPrice(this.props.hotel) }
      </S.Wrapper>
    );
  }
}

HotelMobile.propTypes = {
  modal: PropTypes.func.isRequired,
  hotel: PropTypes.object.isRequired,
  selectedHotel: PropTypes.func.isRequired,
};

export default HotelMobile;



// WEBPACK FOOTER //
// ./src/containers/Hotel/PartnerHotels/HotelMobile.js